/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: debug-service.ts
 *
 * Created by randysorensen on 2019-04-10.
 */

function DebugServiceConstructor(
    this: JS5Object,
    _: JS5Object,
    $window: JS5Object
) {
    //
    // Be very safe here... this can't ever crash a page.
    //

    const supportedLogLevels = [

        //
        // Listed in order of severity, from least to greatest
        //

        'trace',
        'debug',
        'info',
        'warn',
        'error'
    ];

    const loggers: JS5Object = {

        //
        // Function to call on messages, for each of the above
        // log levels
        //

        trace: console.info,
        debug: console.info,
        info: console.info,
        warn: console.warn,
        error: console.error
    };

    const defaultDebugLevel = 'info';

    this.currentLogLevel = _.get($window, '__wfcConfig.debugLevel', defaultDebugLevel);
    this.currentLogLevel = this.currentLogLevel.toLowerCase();

    this.levelEnabled = (level: string) => {
        return supportedLogLevels.indexOf(level) >= supportedLogLevels.indexOf(this.currentLogLevel)
    };

    _.forEach(supportedLogLevels, (level: string) => {
        if (this.levelEnabled(level)) {
            this[level] = function (msg: string) {
                if (msg !== undefined) {
                    const levelUpperCase = _.invoke(level, 'toLocaleUpperCase');
                    const timeStamp = new Date().toISOString();
                    loggers[level](`${levelUpperCase} - ${timeStamp} - ${msg}`);
                }
                return true;
            };
        } else {
            this[level] = () => false;
        }
    });

    this.info(`DebugService: current logging level is "${this.currentLogLevel}"`);
}

angular.module('prism-ui.components').service('DebugService', DebugServiceConstructor);
